import { CpuIcon, DeliveryTruck02Icon, ShieldUserIcon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

const PromoBanner = () => {
	return (
		<section className='container py-8'>
			<div className='grid grid-cols-1 md:grid-cols-3 gap-4'>
				<div
					className='rounded-lg p-6 text-white flex flex-col gap-2 shadow-sm'
					style={{ background: 'linear-gradient(135deg, #1c66a8, #2074be)' }}
				>
					<HugeiconsIcon icon={DeliveryTruck02Icon} size={32} />
					<div className='font-bold text-lg'>Giao trong ngày</div>
					<div className='text-sm opacity-90'>
						Nội thành Hải Phòng - Hà Nội cho đơn trước 14:00. Đối tác Viettel, J&T toàn quốc.
					</div>
				</div>
				<div
					className='rounded-lg p-6 text-white flex flex-col gap-2 shadow-sm'
					style={{ background: 'linear-gradient(135deg, #27353e, #1c272e)' }}
				>
					<HugeiconsIcon icon={CpuIcon} size={32} />
					<div className='font-bold text-lg'>Tư vấn kỹ thuật</div>
					<div className='text-sm opacity-90'>
						Đội kỹ sư cơ điện tử hỗ trợ lựa chọn cấu hình, đấu nối, cài đặt từ xa hoặc tại công trình.
					</div>
				</div>
				<div
					className='rounded-lg p-6 text-white flex flex-col gap-2 shadow-sm'
					style={{ background: 'linear-gradient(135deg, #b91c1c, #ef4444)' }}
				>
					<HugeiconsIcon icon={ShieldUserIcon} size={32} />
					<div className='font-bold text-lg'>Bảo hành tận nơi</div>
					<div className='text-sm opacity-90'>
						Kỹ sư đến tận công trình kiểm tra, đổi mới với thiết bị tự động hoá lớn trong vòng 24h.
					</div>
				</div>
			</div>
		</section>
	);
};

export default PromoBanner;
